<template>
  <div class="transfer-intercept">
    <div class="desc">
      {{
        $t(
          'nin-cun-zai-dui-gong-zhuan-zhang-ding-dan-shang-wei-wan-cheng-zhi-fu-qing-you-xian-chu-li',
        )
      }}
    </div>
    <div class="block">
      <div class="id">
        <span> {{ $t('ding-dan-hao') }} </span>
        <span>{{ order.no }}</span>
      </div>
      <div class="name">
        <span>{{ $t('shang-pin-xin-xi') }}</span>
        <span>{{ order.rights_name }}</span>
      </div>
      <div class="num">
        <span>{{ $t('shu-liang') }}</span>
        <span>{{ displayNum }}</span>
      </div>
      <div v-if="order.expired_time" class="expired">
        <span>{{ $t('you-xiao-qi') }}</span>
        <span>{{ formatTime(order.expired_time) }}</span>
      </div>
      <div class="amount">
        <span>{{ $t('ding-dan-jin-e') }}</span>
        <span>{{ formatPrice(order.pay_fee).string }}</span>
      </div>
    </div>
    <Alert type="warning">
      {{ $t('ding-dan-jiang-yu-1-tian-nei-zi-dong-qu-xiao-qing-ji-shi-wan-cheng-zhi-fu') }}
    </Alert>
    <div class="operation">
      <Button class="btn-cancel" variant="back" @click="onCancelOrder">
        {{ $t('qu-xiao-ding-dan') }}
      </Button>
      <Button class="go-pay" variant="purple" @click="onPay">
        {{ $t('qu-zhi-fu') }}
      </Button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { message } from '@rendora/common/composables/message';
import type { IOrder } from '@rendora/common/entities/order';
import { postOrderClientCancel, postOrderClientPayType } from '@rendora/common/entities/order';
import type { ModalInstance } from '@rendora/common/features/modals/factory';
import { getI18nService } from '@rendora/common/services/i18n';
import { ORDER_TYPE, PAY_TYPE } from '@rendora/common/types/enums';
import { formatFileSize, formatPrice, formatTime } from '@rendora/common/utils/transform';
import { Alert } from '@rendora/design/components/alert/index';
import { Button } from '@rendora/design/components/button/index';
import { computed, inject } from 'vue';

const props = defineProps<{
  order: IOrder;
}>();

const i18nService = getI18nService();
const $t = i18nService.t;

const modalInstance = inject<ModalInstance>('modalInstance')!;

const displayNum = computed(() => {
  const order = props.order!;
  switch (order.order_type) {
    case ORDER_TYPE.STORAGE:
      return formatFileSize(order.rights.total_storage);
    case ORDER_TYPE.CREDITS:
      return $t('orderrightstotalcreditcoin-yan-bi', [order.rights.total_credit_coin]);
    default:
      return order.buy_num;
  }
});

const onCancelOrder = async () => {
  await postOrderClientCancel({ id: props.order.id });
  message.success($t('ding-dan-yi-qu-xiao'));
  modalInstance.close();
};

const onPay = async () => {
  const res = await postOrderClientPayType({
    id: props.order.id,
    pay_type: PAY_TYPE.TRANSFER,
  });

  if (res.data?.qr_code_url) {
    const qrcode = res.data?.qr_code_url;
    location.href = qrcode;
  }
};
</script>

<style lang="scss" scoped>
.transfer-intercept {
  position: relative;
  padding: 20px;
}
.title {
  text-align: center;
  font-weight: var(--x-weight-medium);
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
  color: var(--x-text-1);
}
.desc {
  text-align: center;
  font-size: 14px;
  color: var(--x-text-1);
  line-height: 22px;
  margin-bottom: 20px;
}
.warning-icon {
  position: absolute;
  font-size: 16px;
  right: 12px;
  top: 12px;
  color: var(--x-warning-6);
}
.block {
  background: var(--x-purple-2);
  border-radius: 10px;
  padding: 18px;
  margin-bottom: 14px;
  > div {
    display: flex;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    span {
      display: block;
    }
    span:first-child {
      width: 25%;
    }
  }
}
.operation {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>
